import * as styles from './CloseButton.module.css';

type Props = {
  onClick: () => void;
};

const CloseButton = ({ onClick }: Props) => (
  <button
    data-testid="close-button"
    type="button"
    aria-label="Close button"
    className={styles.closeButton}
    onClick={onClick}
  />
);

export default CloseButton;
